module.exports = __webpack_public_path__ + "media/images/athletes/3329-a601836d6482c27bb3ae90941ffe2ffe.png";